import React, { PureComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { Card, Spin, Button, Icon, message, Modal, Tabs } from 'antd';
import { queryTenantById, updateTenant, deleteTenant, createUser, updateUser, deleteUser } from '../../services/tenantAPI';
import PageHeaderLayout from '../../layouts/PageHeaderLayout';
import DescriptionList from '../../components/DescriptionList';
import EditProfileForm from './EditProfileForm';
import TenantUser from '../TenantUser/TenantUser';
import './TenantProfile.less';

const { Description } = DescriptionList;
const ButtonGroup = Button.Group;
const TabPane = Tabs.TabPane;

class TenantProfile extends PureComponent {
  state = {
    tenant: {
      name: '',
      id: '',
      authType: '',
      workspace: '',
      users: [],
    },
    fetching: true,
    editModalVisible: false,
  };

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;

    const tenantId = this.props.match.params.id;
    const tenantData = await queryTenantById(tenantId);
    if (tenantData && this._isMounted) {
      this.setState({
        tenant: tenantData,
        fetching: false,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleModalVisible = (flag) => {
    this.setState({ editModalVisible: flag });
  };

  editTenantProfile = (data) => {
    // check what data has been updated
    const curProfile = this.state.tenant;
    const oldVal = Object.values(curProfile);
    const newVal = Object.values(data);
    const ifEqual = oldVal.length === newVal.length && oldVal.every((v, i) => v === newVal[i]);

    // if updates is not empty (something actually changed)
    if (!ifEqual) {
      updateTenant(curProfile.id, data)
        .then((updatedTenant) => {
          message.success('Update tenant profile success');
          if (this._isMounted) {
            // update in frontend
            this.setState({ tenant: { ...this.state.tenant, ...updatedTenant } });
          }
        })
        .catch(() => {
          message.error('Update tenant profile failed. Please try again later.');
        });
    }
  };

  handleDeleteClick = (history) => {
    const { tenant } = this.state;
    Modal.confirm({
      title: 'Do you want to delete this tenant?',
      content: tenant.name,
      okText: 'Yes',
      okType: 'danger',
      onOk: () => {
        deleteTenant(tenant.id, () => {
          message.success('Delete tenant success');
          history.push('/tenant');
        });
      },
    });
  };

  addTenantUser = (data) => {
    createUser(this.state.tenant.id, data)
      .then((addedUser) => {
        const newUsers = [...this.state.tenant.users, addedUser];

        if (this._isMounted) {
          this.setState((prevState => ({
            ...prevState,
            tenant: {
              ...prevState.tenant,
              users: newUsers,
            },
          })));
        }

        message.success(`Added user: ${addedUser.email}`);
      })
      .catch(() => {
        message.error('Add user failed. Please try again later.');
      });
  };

  editTenantUser = (userId, data) => {
    const tenantId = this.state.tenant.id;
    updateUser(tenantId, userId, data)
      .then((editedUser) => {
        const newUsers = this.state.tenant.users.map((user) => {
          if (user.id === editedUser.id) {
            return editedUser;
          }
          return user;
        });

        if (this._isMounted) {
          this.setState((prevState => ({
            ...prevState,
            tenant: {
              ...prevState.tenant,
              users: newUsers,
            },
          })));
        }

        message.success(`Updated user: ${editedUser.email}`);
      })
      .catch(() => {
        message.error('Edit user failed. Please try again later.');
      });
  };

  deleteTenantUser = (userId) => {
    const tenantId = this.state.tenant.id;

    deleteUser(tenantId, userId)
      .then(() => {
        const newUsers = this.state.tenant.users.filter((user) => {
          if (user.id === userId) {
            return false;
          }
          return true;
        });

        if (this._isMounted) {
          this.setState((prevState => ({
            ...prevState,
            tenant: {
              ...prevState.tenant,
              users: newUsers,
            },
          })));
        }

        message.success('User deleted');
      })
      .catch(() => {
        message.error('Delete user failed. Please try again later.');
      });
  };

  render() {
    const { match: { path } } = this.props;
    const {
      tenant: {
        name, id, authType, workspace, users,
      }, fetching, editModalVisible,
    } = this.state;

    const DeleteButton = (
      <Route render={({ history }) => (
        <Button type="danger" onClick={() => this.handleDeleteClick(history)}><Icon className="btn-delete" type="delete" />Delete</Button>
      )}
      />
    );
    const action = (
      <Fragment>
        <ButtonGroup>
          <Button onClick={() => { this.handleModalVisible(true); }} ><Icon className="btn-edit" type="edit" />Edit</Button>
          {DeleteButton}
        </ButtonGroup>
      </Fragment>
    );
    const description = (
      <DescriptionList col={24}>
        <Description term="Workspace">{workspace}</Description>
        <Description term="Authorization Type">{authType}</Description>
        <Description term="ID">{id}</Description>
      </DescriptionList>
    );

    return (
      <PageHeaderLayout
        className="tenant-profile"
        title={name}
        path={path}
        action={action}
        content={fetching ? <div style={{ textAlign: 'center' }}><Spin /></div> : description}
      >
        <Card bordered={false}>
          <Tabs defaultActiveKey="users" tabPosition="left">
            <TabPane tab="Users" key="users">
              <TenantUser users={users} addUser={this.addTenantUser} editUser={this.editTenantUser} deleteUser={this.deleteTenantUser} />
            </TabPane>
          </Tabs>
        </Card>
        <EditProfileForm modalVisible={editModalVisible} handleModalVisible={this.handleModalVisible} handleSubmit={this.editTenantProfile} editingTenant={this.state.tenant} />

      </PageHeaderLayout>
    );
  }
}

export default TenantProfile;



// WEBPACK FOOTER //
// ./src/routes/TenantProfile/TenantProfile.js